/**
 * @generated SignedSource<<e4797c00fb78a66b852afdc8f48bebb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DefaultLayout_session$data = {
  readonly cifUserBySub: {
    readonly " $fragmentSpreads": FragmentRefs<"UserProfile_user">;
  } | null;
  readonly " $fragmentType": "DefaultLayout_session";
};
export type DefaultLayout_session$key = {
  readonly " $data"?: DefaultLayout_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"DefaultLayout_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DefaultLayout_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CifUser",
      "kind": "LinkedField",
      "name": "cifUserBySub",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserProfile_user"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "KeycloakJwt",
  "abstractKey": null
};

(node as any).hash = "9b1eff8c818e763785788b82edf18ce7";

export default node;
